import React, { useState, useRef, useEffect } from 'react';

import SelectModal from 'components/Selects/BookingSelectDate/components/Options';
import CustomSelect, { RenderProps as CustomSelectRenderProps } from 'components/Selects/CustomSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useIsMobile from 'hooks/useIsMobile';
interface Traveler {
  id: string;
  userId: string;
  fullName: string;
}

interface Props {
  label?: string;
  initialValue?: string;
  handleChangeTraveler: (id: string) => void;
  className?: string;
  name?: string;
  travelers: Traveler[];
}

const TravelerSelect = ({ label, initialValue, handleChangeTraveler, className, name, travelers }: Props) => {
  const { t } = useStoreTranslation();
  const periodRef = useRef(null);
  const [traveler, setTraveler] = useState<string>(initialValue);
  const transformedTravelers = travelers.map((t, index) => ({ text: t.fullName, value: t.id }));

  const isMobile = useIsMobile();

  const handleChange = (value: string) => {
    setTraveler(value);
    handleChangeTraveler(value);
  };

  useEffect(() => {
    if (initialValue) setTraveler(initialValue);
  }, [initialValue]);

  const makeValue = (traveler: string | undefined) =>
    travelers.find((m) => m.id === traveler || m.userId === traveler)?.fullName ?? travelers.first().fullName;

  return (
    <div className={className} style={{ padding: isMobile ? '15px' : '4px', marginBottom: isMobile ? '5px' : '15px' }}>
      <CustomSelect
        name={name}
        label={label ? label : t('travelerSelect.label')}
        onChange={handleChange}
        placeHolder={t('travelerSelect.placeholder')}
        selectRef={periodRef}
        value={makeValue(traveler)}
      >
        {({ ...selectProps }: CustomSelectRenderProps) => (
          <SelectModal {...selectProps} value={initialValue} selectRef={periodRef} items={transformedTravelers} />
        )}
      </CustomSelect>
    </div>
  );
};

export default TravelerSelect;
